var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "modal-archive-purging-data" } },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.mode === "archive" ? "Archive Data" : "Purging Data"))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "information-wrap" }, [
        _c("img", { attrs: { src: require("@/assets/icon/info.svg") } }),
        _vm._v(" "),
        _c("p", { staticClass: "information-title" }, [_vm._v("Information")]),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _vm.mode === "archive"
          ? _c("p", { staticClass: "information-desc" }, [
              _vm._v(
                "\n      Archiving data runs in the background which takes a long time.\n      You can see this process in the activity log of this data manager.\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mode === "purging"
          ? _c("p", { staticClass: "information-desc" }, [
              _vm._v(
                "\n      Purging data runs in the background which takes a long time.\n      You can see this process in the activity log of this data manager.\n    "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-form",
        { staticClass: "mb-3" },
        [
          _c("label", [_vm._v(" Table ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "error-required": false, disabled: "" },
            model: {
              value: _vm.selectedTableName,
              callback: function($$v) {
                _vm.selectedTableName = $$v
              },
              expression: "selectedTableName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.mode === "archive"
        ? _c(
            "b-form",
            { staticClass: "mb-3" },
            [
              _c("label", [_vm._v(" Last Data on Date ")]),
              _vm._v(" "),
              _c("j-date-time", {
                attrs: {
                  data: _vm.lastData,
                  "max-datetime": _vm.maxLastDate,
                  "error-required": false
                },
                on: { getTimestamp: _vm.setValueLasData }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "purging" && !_vm.isLoading && _vm.lastArchiveInfo
        ? _c("div", { staticClass: "mb-3 archive-info-wrap" }, [
            _c("div", { staticClass: "archive-info-top" }, [
              _c("img", {
                staticClass: "info-image",
                attrs: {
                  src: _vm.lastArchiveInfo.user_info
                    ? _vm.lastArchiveInfo.user_info.photo_url
                    : _vm.defaultImage
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "info-name" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.lastArchiveInfo.user_info
                        ? _vm.lastArchiveInfo.user_info.full_name
                        : ""
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info-time" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.formatDateTime(_vm.lastArchiveInfo.timestamp)) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "archive-info-bottom" }, [
              _c("span", { staticClass: "archive-label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.lastArchiveInfo.action.split("_").join(" ")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _vm.lastArchiveInfo.additional_info &&
              _vm.lastArchiveInfo.additional_info.last_data
                ? _c("span", { staticClass: "date-label" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatDate(
                            _vm.lastArchiveInfo.additional_info.last_data
                          )
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "purging" && !_vm.isLoading && !_vm.lastArchiveInfo
        ? _c("div", { staticClass: "mb-3 archive-not-found" }, [
            _c("p", [
              _vm._v(
                "\n      Archive Data No Available. Please Archive Data First Before Purging.\n    "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "purging" && _vm.isLoading
        ? _c("div", { staticClass: "mb-3 archive-info-skeleton" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form",
        [
          _c("label", [_vm._v("Remarks")]),
          _vm._v(" "),
          _c("j-textarea", {
            model: {
              value: _vm.remarks,
              callback: function($$v) {
                _vm.remarks = $$v
              },
              expression: "remarks"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("b-form", { staticClass: "otp-wrap" }, [
        _c("label", [_vm._v(" OTP (One Time Password) ")]),
        _vm._v(" "),
        !_vm.isShowRequestOtp
          ? _c("div", { staticClass: "message-wrap" }, [
              _vm._v(
                "\n      Please check your inbox, including your spam folder, to find the email containing your OTP.\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-otp-wrap" },
          _vm._l(Object.keys(_vm.otpObject), function(otp, index) {
            return _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.otpObject[otp],
                  expression: "otpObject[otp]"
                }
              ],
              key: otp,
              staticClass: "otp",
              attrs: {
                "tab-index": index,
                disabled: _vm.isDisabledInputOtp,
                type: "text",
                maxlength: "1",
                onkeypress:
                  "return event.charCode >= 48 && event.charCode <= 57"
              },
              domProps: { value: _vm.otpObject[otp] },
              on: {
                keyup: _vm.handleInput,
                paste: _vm.handlePaste,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.otpObject, otp, $event.target.value)
                }
              }
            })
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "otp-info" }, [
          _vm.isShowRequestOtp
            ? _c(
                "span",
                { staticClass: "text-blue", on: { click: _vm.requestOtp } },
                [_vm._v("\n        Request OTP\n      ")]
              )
            : _c("div", [
                !_vm.expired
                  ? _c("p", { staticClass: "text-black" }, [
                      _vm._v(
                        "\n          Code is valid for " +
                          _vm._s(_vm.timerExpiredOtp) +
                          " minutes\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  !_vm.expired
                    ? _c("span", { staticClass: "text-gray" }, [
                        _vm._v("\n            Didn't receive code?\n          ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.expired
                    ? _c("span", { staticClass: "text-gray" }, [
                        _vm._v(
                          "\n            The code has expired,\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "text-blue",
                      class: { "disabled-resend": _vm.isDisabledResendOtp },
                      on: { click: _vm.requestOtp }
                    },
                    [
                      _vm._v("\n            Resend a new code\n            "),
                      _vm.isDisabledResendOtp
                        ? _c("span", [
                            _vm._v(
                              "\n              (" +
                                _vm._s(_vm.timerCountReqNewOtp) +
                                "s)\n            "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "archive-purging-buttons" },
        [
          _c(
            "b-button",
            { staticClass: "white", on: { click: _vm.closeModal } },
            [_vm._v("\n      Close\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "blue",
              attrs: { disabled: !_vm.isShowConfirmBtn },
              on: { click: _vm.handleConfirm }
            },
            [_vm._v("\n      Confirm\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e6054a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e6054a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/popup/ModalArchivePurgingData.vue
// module id = null
// module chunks = 